import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../http.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-front-banner-form',
  templateUrl: './front-banner-form.component.html',
  styleUrls: ['./front-banner-form.component.scss']
})
export class FrontBannerFormComponent implements OnInit {

  public data :any = {status: 1};
  constructor(private http: HttpService, private activatedRoute: ActivatedRoute) { 
    this.activatedRoute.params.subscribe(params => {
      this.init(params['banner_uuid']);
    });
  }

  ngOnInit(): void {
  }

  async init(banner_uuid) {
    this.data = await this.http.post("/admin/app/banner/get", {banner_uuid})
  }

  async loadFile(fileInput: any) {
    this.data.image = await this.http.fileChangeEvent(fileInput);
  }

  async submit() {
    if (!this.data.image) {
      return;
    }

    const t = await this.http.post("/admin/app/banner/save", this.data);

    if(t['status']) {
      this.http.notify("Banner update successfully.")
      this.http.naviBack();
    }
  }
}
